

/**
 * @name TermsController
 * @description Controller for the terms component
 * @param {service} Session The session service
 * @param {service} Auth The auth service
 * @param {service} Collector The collector service
 */
function TermsController(
  Session,
  Auth,
  Collector
) {
  let vm = this;
  vm.agree = agree;
  vm.cancel = cancel;

  /**
   * @name agree
   * @description Function to agree to the terms and privacy policies and update
   * the collector
   */
  function agree() {
    let updatedCollector = Session.collector;
    updatedCollector.accepted_TOS_Privacy = true;
    Collector.updateProfile(updatedCollector).then(function() {
      vm.modalInstance.close();
    });
  }

  /**
   * @name cancel
   * @description Function to not agree and log out
   */
  function cancel() {
    vm.modalInstance.dismiss();
    Auth.logout();
  }
}

angular
  .module('inkfinder')
  .controller('TermsController', TermsController);



// WEBPACK FOOTER //
// ./components/auth/terms/terms.controller.js